import styled from '@emotion/styled';
import { breakpoints } from '../../../utils/styleguide';

const SIZE_TO_PIXELS = {
  S: 10,
  L: 20,
};

const SIZE_TO_PIXELS_DESKTOP = {
  S: 10,
  L: 26,
};

type Props = {
  size: keyof typeof SIZE_TO_PIXELS;
  color: string;
};

const sizeToBorder = ({ size }: Props) => {
  const pixels = SIZE_TO_PIXELS[size];
  return pixelsToBorder(pixels);
};

const sizeToBorderDesktop = ({ size }: Props) => {
  const pixels = SIZE_TO_PIXELS_DESKTOP[size];
  return pixelsToBorder(pixels);
};

const pixelsToBorder = (pixels: number) => `${pixels}px 0 ${pixels}px ${(pixels * 10) / 6}px`;

const PlayArrow = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${sizeToBorder};
  border-color: transparent transparent transparent ${({ color }) => color};
  ${breakpoints.desktop} {
    border-width: ${sizeToBorderDesktop};
  }
`;

export default PlayArrow;
